import { all } from 'redux-saga/effects';
import transactions from './transactions';

export const transactionsSaga = function* root() {
  yield all([transactions()]);
};
